import { c as _c } from "react/compiler-runtime";
import { MouseEvent, MouseEventHandler, useContext } from 'react';
import { useHistory } from 'react-router';
import { NavLink, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import useSWR from 'swr';
import APIMethodKeys from '../../../client/APIMethodKeys';
import { storage_keys } from '../../../utils/storage';
import { formatPath } from '../../../utils/path';
import Avatar from '../../common/base/Avatar';
import Badge from '../../common/base/Badge';
import { ClickableArea } from '../../common/base/Button';
import Divider from '../../common/base/Divider';
import Icon, { IconName } from '../../common/base/Icon';
import Link from '../../common/base/Link';
import Text from '../../common/base/Text';
import Tooltip from '../../common/base/Tooltip';
import Dropdown from '../../common/Dropdown';
import DropdownMenu from '../../common/DropdownMenu';
import { Div } from '../../common/helpers/StyledUtils';
import { GlobalContext } from '../../contexts/GlobalContext';
import useLocalStorage from '../../hooks/useLocalStorage';
import { DashboardContext } from '../DashboardScene/DashboardContext';
import { DashboardNavShell, NavSections, ScrollContainer, StyledCollapsedLinkWrapper, StyledNavLinks, StyledViewsContainer } from '../DashboardScene/Nav';
import CollapsedNavIcon from '../DashboardScene/Nav/CollapsedNavIcon';
import { ViewsContext, ViewsContextProvider } from '../DashboardScene/ViewsContext';
import OutpostNavFooter from './OutpostNavFooter';
import { useOutpostConfig } from './OutpostContext';
import TeamSelection from '../DashboardScene/Nav/TeamSelection/TeamSelection';
const Views: React.FC<{
  base_path: '/events' | '/deliveries';
  compact?: boolean;
  include_all?: boolean;
  toggle?: (show: boolean) => void;
}> = t0 => {
  const $ = _c(27);
  const {
    base_path,
    compact: t1,
    include_all: t2,
    toggle
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const include_all = t2 === undefined ? false : t2;
  const {
    views
  } = useContext(ViewsContext);
  const {
    pathname
  } = useLocation();
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== base_path || $[1] !== compact || $[2] !== include_all || $[3] !== pathname || $[4] !== toggle || $[5] !== views.models) {
    const all_views = views.models.sort(_temp);
    const displayed_views = compact ? all_views : views.models.filter((view, i) => i < 5 || pathname === `${base_path}/${formatPath(view.name, {
      escape_parentheses: false
    })}`);
    T0 = StyledNavLinks;
    t3 = compact ? "neutral" : undefined;
    if ($[11] !== base_path || $[12] !== compact || $[13] !== include_all || $[14] !== pathname || $[15] !== toggle) {
      t4 = include_all && <NavLink to={base_path} isActive={() => pathname === base_path} onClick={() => toggle?.(false)}><Div p={compact ? {
          x: 1
        } : {
          x: 0.5
        }} w={100}><Text semi={true} ellipsis={true}>All</Text></Div></NavLink>;
      $[11] = base_path;
      $[12] = compact;
      $[13] = include_all;
      $[14] = pathname;
      $[15] = toggle;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    let t7;
    if ($[17] !== base_path || $[18] !== compact || $[19] !== toggle) {
      t7 = view_0 => <NavLink key={view_0.id} to={`${base_path}/${formatPath(view_0.name, {
        escape_parentheses: false
      })}`} onClick={() => toggle?.(false)}><Div p={compact ? {
          x: 1
        } : {
          x: 0.5
        }} w={100} flex={{
          align: "center",
          justify: "space-between"
        }}><Text semi={true} ellipsis={true}>{view_0.name}</Text></Div></NavLink>;
      $[17] = base_path;
      $[18] = compact;
      $[19] = toggle;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    t5 = displayed_views.map(t7);
    t6 = displayed_views.length < all_views.length && <DropdownMenu placement="right-start" block={true} p={0} search={true} search_placeholder="Find a saved view..." parent_width={{
      min: 248,
      max: 248
    }} renderToggle={(opened, toggle_0) => <StyledNavLinks $hover_background={compact ? "neutral" : undefined}><ClickableArea highlight={opened} on={compact ? undefined : "background"} onClick={() => toggle_0(!opened)}><Div p={compact ? {
          x: 1
        } : undefined} w={100}><Text semi={true} ellipsis={true} muted={!opened}>See all {views?.models.length} views...</Text></Div></ClickableArea></StyledNavLinks>} options={all_views.map(view_1 => ({
      label: view_1.name,
      value: view_1.id,
      to: `${base_path}/${formatPath(view_1.name, {
        escape_parentheses: false
      })}`
    }))} />;
    $[0] = base_path;
    $[1] = compact;
    $[2] = include_all;
    $[3] = pathname;
    $[4] = toggle;
    $[5] = views.models;
    $[6] = T0;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[21] !== T0 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t7 = <T0 $hover_background={t3}>{t4}{t5}{t6}</T0>;
    $[21] = T0;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
const TOTAL_GET_STARTED_STEPS = 5;
const GetStartedNavLink = styled(StyledNavLinks)`
  margin-top: ${({
  theme
}) => theme.spacing(3)};
`;
const GetStartedCloseButton = t0 => {
  const $ = _c(6);
  const {
    hide: t1,
    onClick
  } = t0;
  const hide = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [-7, 12];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onClick) {
    t3 = <Tooltip tooltip="Dismiss tab" align="right" offset={t2}><Link small={true} neutral={true} icon="close" onClick={onClick} /></Tooltip>;
    $[1] = onClick;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== hide || $[4] !== t3) {
    t4 = <StyledGetStartedCloseButton hide={hide}>{t3}</StyledGetStartedCloseButton>;
    $[3] = hide;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
const StyledGetStartedCloseButton = styled.div<{
  hide: boolean;
}>`
  visibility: ${({
  hide
}) => hide ? 'hidden' : 'visible'};
  position: absolute;
  right: ${({
  theme
}) => theme.spacing(1.5)};
  top: ${({
  theme
}) => theme.spacing(0)};
  bottom: ${({
  theme
}) => theme.spacing(0)};
  display: flex;

  ${GetStartedNavLink}:hover & {
    visibility: visible;
    width: auto;
  }
`;
const GetStartedBadge = styled(Badge)`
  visibility: visible;
  position: absolute;
  right: ${({
  theme
}) => theme.spacing(1)};

  ${GetStartedNavLink}:hover & {
    visibility: hidden;
  }
`;
const useGetStartedProgress = () => {
  const $ = _c(14);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    config
  } = useOutpostConfig();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.outpost.tenants.list({
      limit: 1
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.outpost.tenants) {
    t1 = () => HookdeckAPI.outpost.tenants.list({
      limit: 1
    }).then(_temp2);
    $[1] = HookdeckAPI.outpost.tenants;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: tenant
  } = useSWR(`${t0}:single`, t1);
  let t2;
  if ($[3] !== tenant) {
    t2 = tenant ? `${APIMethodKeys.outpost.destinations.list(tenant.id, {
      limit: 1
    })}:single` : null;
    $[3] = tenant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== HookdeckAPI.outpost.destinations || $[6] !== tenant?.id) {
    t3 = () => HookdeckAPI.outpost.destinations.list(tenant?.id as string, {
      limit: 1
    }).then(_temp3);
    $[5] = HookdeckAPI.outpost.destinations;
    $[6] = tenant?.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: destination
  } = useSWR(t2, t3);
  let t4;
  if ($[8] !== destination || $[9] !== tenant?.id) {
    t4 = destination ? `${APIMethodKeys.outpost.events.list({
      limit: 1,
      tenant_id: tenant?.id
    })}:single` : null;
    $[8] = destination;
    $[9] = tenant?.id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== HookdeckAPI.outpost.events || $[12] !== tenant?.id) {
    t5 = () => HookdeckAPI.outpost.events.list({
      limit: 1,
      tenant_id: tenant?.id
    }).then(_temp4);
    $[11] = HookdeckAPI.outpost.events;
    $[12] = tenant?.id;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const {
    data: event
  } = useSWR(t4, t5);
  const topics_done = !!(config && config.TOPICS && config.TOPICS.length > 0);
  const tenant_done = !!tenant;
  const destination_done = !!destination;
  const event_done = !!event;
  return event_done ? 5 : destination_done ? 4 : tenant_done ? 3 : topics_done ? 2 : 1;
};
const OutpostNav = () => {
  const $ = _c(86);
  const {
    organization,
    team,
    nav_collapsed
  } = useContext(DashboardContext);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const history = useHistory();
  const {
    pathname
  } = useLocation();
  const [show_get_started, setShowGetStarted] = useLocalStorage(`${storage_keys.show_outpost_get_started}:${team?.id}`, true);
  const get_started_progress = useGetStartedProgress();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.views.list({
      type: "outpost_events"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.views) {
    t1 = () => HookdeckAPI.views.list({
      type: "outpost_events"
    });
    $[1] = HookdeckAPI.views;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: event_views
  } = useSWR(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = APIMethodKeys.views.list({
      type: "outpost_attempts"
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.views) {
    t3 = () => HookdeckAPI.views.list({
      type: "outpost_attempts"
    });
    $[4] = HookdeckAPI.views;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: attempt_views
  } = useSWR(t2, t3);
  const get_started_remaining_steps = TOTAL_GET_STARTED_STEPS - get_started_progress;
  let t4;
  if ($[6] !== history || $[7] !== pathname || $[8] !== setShowGetStarted) {
    t4 = e => {
      e.preventDefault();
      setShowGetStarted(false);
      if (pathname === "/") {
        history.push("/tenants");
      }
    };
    $[6] = history;
    $[7] = pathname;
    $[8] = setShowGetStarted;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const closeGetStarted = t4;
  let t5;
  if ($[10] !== nav_collapsed) {
    t5 = (icon, label) => {
      if (!nav_collapsed) {
        return <Icon left={true} icon={icon} pointer={true} p={0.5} />;
      }
      return <Tooltip tooltip={label} side="right" align="center" offset={[0, 12]}><CollapsedNavIcon icon={icon} left={true} /></Tooltip>;
    };
    $[10] = nav_collapsed;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const navIcon = t5;
  let t6;
  if ($[12] !== nav_collapsed || $[13] !== organization.name || $[14] !== team) {
    t6 = (opened, toggle) => <ClickableArea on="background" rounded={true} block={!nav_collapsed} highlight={opened} flex={{
      align: "center"
    }} onClick={() => toggle(!opened)} p={1}><Avatar name={organization.name} small={true} />{!nav_collapsed && <Text ellipsis={true} text_wrap={false} semi={true} p={{
        l: 2,
        r: 1
      }}>{team.name}</Text>}{!nav_collapsed && <Icon muted={true} icon="expand_all" m={{
        l: "auto"
      }} pointer={true} />}</ClickableArea>;
    $[12] = nav_collapsed;
    $[13] = organization.name;
    $[14] = team;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const project_picker_toggle = t6;
  const collapsedViewsFlyout = _temp5;
  let t7;
  if ($[16] !== pathname) {
    t7 = t8 => {
      const {
        to,
        label: label_0,
        icon: icon_0,
        type: type_0,
        base_path: base_path_0
      } = t8;
      return <Dropdown portal={true} on_hover={true} placement="right-start" renderToggle={(opened_0, toggle_1) => <StyledCollapsedLinkWrapper><NavLink to={to} aria-label={label_0} isActive={() => opened_0 || pathname.startsWith(to)} onClick={() => toggle_1(false)}><Icon left={true} icon={icon_0} pointer={true} p={0.5} /></NavLink></StyledCollapsedLinkWrapper>}>{toggle_2 => collapsedViewsFlyout(type_0, base_path_0, toggle_2)}</Dropdown>;
    };
    $[16] = pathname;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const collapsedViewsDropdown = t7;
  let t8;
  if ($[18] !== nav_collapsed || $[19] !== project_picker_toggle || $[20] !== team) {
    t8 = nav_collapsed ? <Div m={{
      y: 3
    }} flex={{
      justify: "center"
    }}><Dropdown placement="right-start" p={0} renderToggle={(opened_1, toggle_3) => <Tooltip tooltip={team.name} side="right" align="center" offset={[0, 8]}>{project_picker_toggle(opened_1, toggle_3)}</Tooltip>}><TeamSelection /></Dropdown></Div> : <Div m={{
      x: 2,
      y: 3
    }}><Dropdown block={true} placement="bottom-start" p={0} renderToggle={(opened_2, toggle_4) => project_picker_toggle(opened_2, toggle_4)}><TeamSelection /></Dropdown></Div>;
    $[18] = nav_collapsed;
    $[19] = project_picker_toggle;
    $[20] = team;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Divider />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== nav_collapsed) {
    t10 = nav_collapsed ? {
      x: 2,
      y: 3
    } : {
      x: 2,
      b: 3
    };
    $[23] = nav_collapsed;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== closeGetStarted || $[26] !== get_started_remaining_steps || $[27] !== navIcon || $[28] !== nav_collapsed || $[29] !== show_get_started) {
    t11 = show_get_started !== false && <GetStartedNavLink><NavLink exact={true} to="/get-started" aria-label={nav_collapsed ? "Get Started" : undefined}>{navIcon("grid_view", "Get Started")}{!nav_collapsed && <><Text semi={true} size="m" w={100} flex={{
            justify: "space-between"
          }}>Get Started</Text><>{get_started_remaining_steps > 0 && <GetStartedBadge primary={true} subtle={true}>{get_started_remaining_steps}</GetStartedBadge>}<GetStartedCloseButton onClick={closeGetStarted} /></></>}</NavLink></GetStartedNavLink>;
    $[25] = closeGetStarted;
    $[26] = get_started_remaining_steps;
    $[27] = navIcon;
    $[28] = nav_collapsed;
    $[29] = show_get_started;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = nav_collapsed ? "Tenants" : undefined;
  let t13;
  if ($[31] !== navIcon) {
    t13 = navIcon("group", "Tenants");
    $[31] = navIcon;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== nav_collapsed) {
    t14 = !nav_collapsed && <Text semi={true} size="m">Tenants</Text>;
    $[33] = nav_collapsed;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t13 || $[37] !== t14) {
    t15 = <NavSections title="Configure"><StyledNavLinks><NavLink to="/tenants" aria-label={t12}>{t13}{t14}</NavLink></StyledNavLinks></NavSections>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const t16 = nav_collapsed ? "Metrics" : undefined;
  let t17;
  if ($[39] !== navIcon) {
    t17 = navIcon("metrics", "Metrics");
    $[39] = navIcon;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== nav_collapsed) {
    t18 = !nav_collapsed && <Text semi={true} size="m">Metrics</Text>;
    $[41] = nav_collapsed;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t16 || $[44] !== t17 || $[45] !== t18) {
    t19 = <NavLink to="/metrics" aria-label={t16}>{t17}{t18}</NavLink>;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  const t20 = nav_collapsed ? "Operator Events" : undefined;
  let t21;
  if ($[47] !== navIcon) {
    t21 = navIcon("notification", "Operator Events");
    $[47] = navIcon;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== nav_collapsed) {
    t22 = !nav_collapsed && <Text semi={true} size="m">Operator Events</Text>;
    $[49] = nav_collapsed;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t20 || $[52] !== t21 || $[53] !== t22) {
    t23 = <NavLink to="/operator-events" aria-label={t20}>{t21}{t22}</NavLink>;
    $[51] = t20;
    $[52] = t21;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t19 || $[56] !== t23) {
    t24 = <NavSections title="Monitor"><StyledNavLinks>{t19}{t23}</StyledNavLinks></NavSections>;
    $[55] = t19;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== collapsedViewsDropdown || $[59] !== event_views || $[60] !== navIcon || $[61] !== nav_collapsed || $[62] !== pathname) {
    t25 = nav_collapsed && event_views && event_views.count > 0 ? collapsedViewsDropdown({
      to: "/events",
      label: "Events",
      icon: "source",
      type: "outpost_events",
      base_path: "/events"
    }) : <><NavLink to="/events" aria-label={nav_collapsed ? "Events" : undefined} isActive={() => pathname.startsWith("/events")}>{navIcon("source", "Events")}{!nav_collapsed && <Text semi={true} size="m">Events</Text>}</NavLink>{!nav_collapsed && event_views && event_views.count > 0 && <ViewsContextProvider type="outpost_events" redirect_root="/events"><Route path="/events"><StyledViewsContainer flex={{
            direction: "column"
          }}><Div m={{
              l: 6.5
            }} flex={{
              direction: "column"
            }}><Views base_path="/events" /></Div></StyledViewsContainer></Route></ViewsContextProvider>}</>;
    $[58] = collapsedViewsDropdown;
    $[59] = event_views;
    $[60] = navIcon;
    $[61] = nav_collapsed;
    $[62] = pathname;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== attempt_views || $[65] !== collapsedViewsDropdown || $[66] !== navIcon || $[67] !== nav_collapsed || $[68] !== pathname) {
    t26 = nav_collapsed && attempt_views && attempt_views.count > 0 ? collapsedViewsDropdown({
      to: "/deliveries",
      label: "Deliveries",
      icon: "events",
      type: "outpost_attempts",
      base_path: "/deliveries"
    }) : <><NavLink to="/deliveries" aria-label={nav_collapsed ? "Deliveries" : undefined} isActive={() => pathname.startsWith("/deliveries")}>{navIcon("events", "Deliveries")}{!nav_collapsed && <Text semi={true} size="m">Deliveries</Text>}</NavLink>{!nav_collapsed && attempt_views && attempt_views.count > 0 && <ViewsContextProvider type="outpost_attempts" redirect_root="/deliveries"><Route path="/deliveries"><StyledViewsContainer flex={{
            direction: "column"
          }}><Div m={{
              l: 6.5
            }} flex={{
              direction: "column"
            }}><Views base_path="/deliveries" /></Div></StyledViewsContainer></Route></ViewsContextProvider>}</>;
    $[64] = attempt_views;
    $[65] = collapsedViewsDropdown;
    $[66] = navIcon;
    $[67] = nav_collapsed;
    $[68] = pathname;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  let t27;
  if ($[70] !== t25 || $[71] !== t26) {
    t27 = <NavSections title="Inspect"><StyledNavLinks>{t25}{t26}</StyledNavLinks></NavSections>;
    $[70] = t25;
    $[71] = t26;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t10 || $[74] !== t11 || $[75] !== t15 || $[76] !== t24 || $[77] !== t27) {
    t28 = <ScrollContainer p={t10}>{t11}{t15}{t24}{t27}</ScrollContainer>;
    $[73] = t10;
    $[74] = t11;
    $[75] = t15;
    $[76] = t24;
    $[77] = t27;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== setShowGetStarted || $[80] !== show_get_started) {
    t29 = <OutpostNavFooter show_get_started={show_get_started} setShowGetStarted={setShowGetStarted} />;
    $[79] = setShowGetStarted;
    $[80] = show_get_started;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  let t30;
  if ($[82] !== t28 || $[83] !== t29 || $[84] !== t8) {
    t30 = <DashboardNavShell>{t8}{t9}{t28}{t29}</DashboardNavShell>;
    $[82] = t28;
    $[83] = t29;
    $[84] = t8;
    $[85] = t30;
  } else {
    t30 = $[85];
  }
  return t30;
};
export default OutpostNav;
function _temp(a, b) {
  return a.name.localeCompare(b.name);
}
function _temp2(data) {
  return data.models.length > 0 ? data.models[0] : null;
}
function _temp3(data_0) {
  return data_0.length > 0 ? data_0[0] : null;
}
function _temp4(data_1) {
  return data_1.models.length > 0 ? data_1.models[0] : null;
}
function _temp5(type, base_path, toggle_0) {
  return <Div min_w={{
    px: 248
  }}><ViewsContextProvider type={type} redirect_root={base_path}><Views base_path={base_path} compact={true} include_all={true} toggle={toggle_0} /></ViewsContextProvider></Div>;
}